import { render, staticRenderFns } from "./DynTable.vue?vue&type=template&id=1327505c&scoped=true"
import script from "./DynTable.vue?vue&type=script&lang=js"
export * from "./DynTable.vue?vue&type=script&lang=js"
import style0 from "./DynTable.vue?vue&type=style&index=0&id=1327505c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1327505c",
  null
  
)

export default component.exports